import { render, staticRenderFns } from "./AreaListContainer.vue?vue&type=template&id=72bb277a"
import script from "./AreaListContainer.vue?vue&type=script&lang=js"
export * from "./AreaListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports